<template>
    <div>
        <v-card flat class="pa-4 bar">
            <div class="d-flex justify-end align-center">
				<v-btn 
					small 
					class="btn-save"
					@click="manageprint"
				>
					<v-icon>
						mdi-printer
					</v-icon>
				</v-btn>
				<v-btn 
					small 
					class="btn-save ml-2"
					@click="getGeneralLedger()"
				>
					<v-icon>
						mdi-magnify
					</v-icon>
				</v-btn>
            </div>
        </v-card>

        <v-row class="mx-1 mt-5">
            <v-col cols="12" md="6">
                <v-select
                    v-model="search.month"
                    :items="monthList"
                    item-text="text"
                    item-value="value"
                    label="Mes"
                    outlined
                    attach
                    dense
                ></v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    v-model="search.year"
                    label="Año"
                    outlined
                    type="number"
                    attach
                    dense
                    clearable
                ></v-text-field>
            </v-col>
        </v-row>

		<v-row v-if="loading">
			<v-col>
				<v-progress-linear indeterminate color="primary" class="mb-2"></v-progress-linear>
			</v-col>
		</v-row>

        <DxDataGrid 
			class="general-ledger-grid"
			:dataSource="DataTable"
			:showBorders="true"
			:scrolling="{ useNative: true }"    
			:column-auto-width="true"
			:paging="{ enabled: false }"  
			no-data-text="No se encontraron datos"
			@row-prepared="onRowPrepared"
			style="max-height: 600px"
        >
            <DxColumn width="13%" dataField="account_code" caption="Cuenta" />
            <DxColumn width="31%" dataField="concept" caption="Nombre de la cuenta" />
            <DxColumn width="14%" dataField="initial_balance_formatted" caption="Saldo inicial" cell-template="money-template" header-cell-template="centered-money-header" />
            <DxColumn width="14%" dataField="charges_formatted" caption="Cargos" cell-template="money-template" header-cell-template="centered-money-header" />
            <DxColumn width="14%" dataField="payments_formatted" caption="Abonos" cell-template="money-template" header-cell-template="centered-money-header" />
            <DxColumn width="14%" dataField="current_balance_formatted" caption="Saldo final" cell-template="money-template" header-cell-template="centered-money-header" />
			<template #centered-money-header="{ data }">
				<div class="ledger-money-header">{{ data.column.caption }}</div>
			</template>
			<template #money-template="{ data }">
				<div class="ledger-money-cell">
					<span class="ledger-money-symbol">{{ Currency }}</span>
					<span class="ledger-money-value">{{ getMoneyValue(data.value) }}</span>
				</div>
			</template>
        </DxDataGrid>
        <alerts
			v-if="alert.show"
			v-on:close_alert="closeAlert"
			v-on:accept_alert="acceptAlert"
			:properties="alert"
		></alerts>
		<PrintGeneralLedger :dataProps="print"></PrintGeneralLedger>
    </div>
</template>

<script>
import {DxDataGrid, DxColumn} from 'devextreme-vue/data-grid';
import PrintGeneralLedger from '../../../components/ReportsAndPrintings/PrintGeneralLedger.vue';
import alerts from '@/components/Alerts.vue';
export default {
	name: "Book",
	components: {
		DxDataGrid,
		DxColumn,
		alerts,
		PrintGeneralLedger
	},
	props: ['win'],
	data() {
		return {
			DataTable: [],
			panel: 0,
			tab: null,
			key: 0,
			search:{
				month: null,
				year: null,
			},
			alert: {
				type: "success",
				show: false,
				header: "",
				body: "",
			},
			monthList: [
				{text: 'Enero', value: 1},
				{text: 'Febrero', value: 2},
				{text: 'Marzo', value: 3},
				{text: 'Abril', value: 4},
				{text: 'Mayo', value: 5},
				{text: 'Junio', value: 6},
				{text: 'Julio', value: 7},
				{text: 'Agosto', value: 8},
				{text: 'Septiembre', value: 9},
				{text: 'Octubre', value: 10},
				{text: 'Noviembre', value: 11},
				{text: 'Diciembre', value: 12},
			],
			Currency: JSON.parse(localStorage.getItem('branch')).Currency,
			print: {
				show: false,
				data: [],
			},
			loading: false,
			searchbusiness: {},
			infobusiness: {},
		}
	},
	computed:{
		columnWidth() {
			return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
		},
	},
	mounted() {
		this.searchbusiness.branch = JSON.parse(localStorage.getItem("user")).branch || "";
		this.searchbusiness.business = JSON.parse(localStorage.getItem("user")).businessid || "";
		this.getInfoBusiness()
	},
	methods: {
		async getInfoBusiness() {
			let response = await this.$API.branches.findSpecificBranch(this.searchbusiness)
			this.infobusiness = response[0]
		},
		closeAlert() {
			this.alert.show = false;
		},
		acceptAlert() {
			this.alert.show = false;

			if (this.alert.options == "deletecustomer") {
				this.deleteCustomer();
			}
		},
		showAlert(type, header, body, options = null) {
			type = type == null ? "danger" : type;
			this.alert.type = type;
			this.alert.header = header;
			this.alert.body = body;
			this.alert.show = true;
			this.alert.options = options != null ? options : null;
		},
		setupData(data){
			const rows = Array.isArray(data) ? data : [];

			this.DataTable = rows
				.filter((item) => this.isMajorAccountSummary(item))
				.map((item, index) => this.normalizeLedgerRow(item, index))
				.sort((a, b) => this.compareAccountCodes(a.account_code, b.account_code));
		},
		getAccountCode(item = {}) {
			return String(item.account_code || item.main_column || item.CuentaDeMayor || "").trim();
		},
		getAccountLevel(item = {}) {
			const explicitLevel = item.account_level || item.level || item.level_number || item.Nivel;

			if (explicitLevel != null) {
				const level = parseInt(String(explicitLevel).replace(/\D/g, ""), 10);
				if (!Number.isNaN(level)) {
					return level;
				}
			}

			const code = this.getAccountCode(item);

			if (!code) {
				return 0;
			}

			if (code.includes(".") || code.includes("-")) {
				return code.split(/[.-]/).filter(Boolean).length;
			}

			const normalizedCode = code.replace(/\D/g, "");

			if (normalizedCode.length <= 1) return 1;
			if (normalizedCode.length <= 2) return 2;
			if (normalizedCode.length <= 4) return 3;

			return 4;
		},
		isMajorAccountSummary(item = {}) {
			const recordType = item.record_type == null ? 0 : Number(item.record_type);
			const accountLevel = this.getAccountLevel(item);

			return recordType === 0 && accountLevel >= 1 && accountLevel <= 3;
		},
		normalizeAmount(value) {
			if (typeof value === "number") {
				return Number.isFinite(value) ? value : 0;
			}

			const normalizedValue = String(value || "")
				.replace(this.Currency, "")
				.replace(/\$/g, "")
				.replace(/,/g, "")
				.trim();
			const numericValue = parseFloat(normalizedValue);

			return Number.isNaN(numericValue) ? 0 : numericValue;
		},
		formatAmount(value) {
			return `${this.Currency} ${this.normalizeAmount(value).toFixed(2)}`;
		},
		getMoneyValue(value) {
			return this.normalizeAmount(value).toFixed(2);
		},
		normalizeLedgerRow(item, index) {
			const accountCode = this.getAccountCode(item);
			const accountName = item.concept || item.NombreCuenta || item.account_description || "";
			const accountLevel = this.getAccountLevel(item);
			const initialBalance = this.normalizeAmount(item.initial_balance != null ? item.initial_balance : item.SaldoAnterior);
			const charges = this.normalizeAmount(item.charges != null ? item.charges : item.Debe);
			const payments = this.normalizeAmount(item.payments != null ? item.payments : item.Haber);
			const currentBalance = this.normalizeAmount(item.current_balance != null ? item.current_balance : item.SaldoTotal);
			const initialBalanceFormatted = this.formatAmount(initialBalance);
			const chargesFormatted = this.formatAmount(charges);
			const paymentsFormatted = this.formatAmount(payments);
			const currentBalanceFormatted = this.formatAmount(currentBalance);

			return {
				...item,
				numberAccount: index + 1,
				account_code: accountCode,
				main_column: item.main_column || accountCode,
				concept: accountName,
				account_level: accountLevel,
				initial_balance: initialBalance,
				charges,
				payments,
				current_balance: currentBalance,
				initial_balance_formatted: initialBalanceFormatted,
				charges_formatted: chargesFormatted,
				payments_formatted: paymentsFormatted,
				current_balance_formatted: currentBalanceFormatted,
				CuentaDeMayor: accountCode,
				NombreCuenta: accountName,
				SalAnterior: initialBalanceFormatted,
				SaldoAnterior: initialBalanceFormatted,
				Debe: chargesFormatted,
				Haber: paymentsFormatted,
				Hasta: paymentsFormatted,
				SaldoTotal: currentBalanceFormatted,
				ClaseDeCuenta: accountLevel,
			};
		},
		compareAccountCodes(firstCode, secondCode) {
			return String(firstCode).trim().localeCompare(String(secondCode).trim(), undefined, {
				sensitivity: "base",
			});
		},
		onRowPrepared(e) {
			if (e.rowType !== "data" || !e.data) {
				return;
			}

			const className = `ledger-level-${e.data.account_level}`;

			if (e.rowElement.classList) {
				e.rowElement.classList.add(className);
			}
			else if (e.rowElement.addClass) {
				e.rowElement.addClass(className);
			}
		},
		async getGeneralLedger(){
			if(this.search.month == null || this.search.year == null){
				this.showAlert("danger", "Error", "Debe seleccionar un mes y un año");
				return;
			}
			if(String(this.search.year).length != 4){
				this.showAlert("danger", "Error", "El año debe tener 4 digitos");
				return;
			}

			this.loading = true;

			try {
				let response = await this.$API.accountingreports.getGeneralLedgerData(this.search)

				if (!Array.isArray(response)) {
					throw new Error("Invalid general ledger response");
				}
				
				this.setupData(response);

				if(this.DataTable.length === 0){
					this.showAlert("warning", "Sin resultados", "No se encontraron datos para el periodo seleccionado");
				}
			}
			catch (error) {
				this.DataTable = [];
				this.showAlert("danger", "Error", "No fue posible consultar el libro mayor");
			}
			finally {
				this.loading = false;
			}
		},
		async manageprint() {
			let branchinfo = JSON.parse(localStorage.getItem("branch"));
			
			this.print = {
				show: true,
				data: {
					body: this.DataTable,
					branch: branchinfo,
					business: this.infobusiness,
					date: this.search,
					bookType: this.DailyMayorBookType,
					summaryMode: true,
				},
			};
		}
	},
}
</script>

<style scoped>
.bar {
  max-width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin: 16px 12px !important;
}
.btn-add{
  background-color: #3498DB  !important;
  color: white;
}
.btnsave{
  background-color: #00A178 !important;
  color: white;
}
.btnclean{
  background-color: #F29D35 !important;
  color: white;
}
.btndelete{
  background-color: #E3191E !important;
  color: white;
}
::v-deep .general-ledger-grid .ledger-level-1 > td {
  font-weight: 700;
}
::v-deep .general-ledger-grid .ledger-level-2 > td {
  font-weight: 400;
}
::v-deep .general-ledger-grid .ledger-level-3 > td {
  font-weight: 400;
}
::v-deep .general-ledger-grid .ledger-money-header {
  width: 100%;
  text-align: center;
}
::v-deep .general-ledger-grid .ledger-money-cell {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  box-sizing: border-box;
  padding-left: 8px;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
::v-deep .general-ledger-grid .ledger-money-symbol {
  flex: 0 0 auto;
  text-align: left;
}
::v-deep .general-ledger-grid .ledger-money-value {
  flex: 1 1 auto;
  text-align: right;
}
</style>
